export default "__VITE_ASSET__CTnikh$T__"